var _level1ItemsData;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { formatPercentageValue, formatNumberToLocale } from '../../helpers/numberFormatter';
import * as level1DataProp from '../../propTypes/level1Data';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import { instrumentPropType } from '../../propTypes/instrumentPropTypes';
import InstrumentTableItem from './InstrumentTableItem';
import INSTRUMENT_TABLE_ITEMS from './InstrumentTableItems';
import { convertIncrementToIntDecimalPlaces } from '../../helpers/decimalPlaces/decimalPlacesHelper';
import './InstrumentTableComponent.css';
var getProductSymbol = function getProductSymbol(instrument) {
  return get(instrument, 'Product1Symbol', '');
};
var InstrumentTableComponent = function InstrumentTableComponent(props, context) {
  var t = context.t;
  var level1 = props.level1,
    selectedInstrument = props.selectedInstrument,
    items = props.items,
    customClass = props.customClass;
  var baseClasses = getBEMClasses(['instrument-table', customClass]);
  var productSymbol = get(selectedInstrument, 'Product1Symbol', '');
  var priceSymbol = get(selectedInstrument, 'Product2Symbol', '');
  var instrumentTableItems = items.map(function (item) {
    return level1ItemsData[item.field](t, level1, selectedInstrument);
  });
  return React.createElement('div', {
    className: baseClasses()
  }, customClass === 'market-overview-instrument' && React.createElement('div', {
    className: baseClasses('row')
  }, React.createElement('span', {
    className: baseClasses('title')
  }, t('' + productSymbol + priceSymbol + ' Price Data:'))), instrumentTableItems.map(function (_ref) {
    var key = _ref.key,
      value = _ref.value,
      label = _ref.label,
      classModifiers = _ref.classModifiers;
    return React.createElement(InstrumentTableItem, {
      key: key,
      value: value,
      label: label,
      baseClasses: baseClasses,
      classModifiers: classModifiers
    });
  }));
};
InstrumentTableComponent.propTypes = {
  level1: level1DataProp.type.isRequired,
  selectedInstrument: instrumentPropType,
  items: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string.isRequired
  }))
};
InstrumentTableComponent.defaultProps = {
  level1: level1DataProp.defaultProps,
  items: [{
    field: INSTRUMENT_TABLE_ITEMS.lastPrice
  }, {
    field: INSTRUMENT_TABLE_ITEMS.dailyPercentageChange
  }, {
    field: INSTRUMENT_TABLE_ITEMS.bid
  }, {
    field: INSTRUMENT_TABLE_ITEMS.ask
  }, {
    field: INSTRUMENT_TABLE_ITEMS.dailyVolume
  }, {
    field: INSTRUMENT_TABLE_ITEMS.dailyMin
  }, {
    field: INSTRUMENT_TABLE_ITEMS.dailyMax
  }]
};
InstrumentTableComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default InstrumentTableComponent;
var level1ItemsData = (_level1ItemsData = {}, _defineProperty(_level1ItemsData, INSTRUMENT_TABLE_ITEMS.lastPrice, function (t, _ref2, instrument) {
  var LastTradedPx = _ref2.LastTradedPx;
  return {
    key: INSTRUMENT_TABLE_ITEMS.lastPrice,
    value: formatNumberToLocale(LastTradedPx, convertIncrementToIntDecimalPlaces(get(instrument, 'PriceIncrement', 0))),
    label: t('Last Price'),
    classModifiers: ['last-price']
  };
}), _defineProperty(_level1ItemsData, INSTRUMENT_TABLE_ITEMS.dailyPercentageChange, function (t, _ref3, instrument) {
  var Rolling24HrPxChangePercent = _ref3.Rolling24HrPxChangePercent;
  return {
    key: INSTRUMENT_TABLE_ITEMS.dailyPercentageChange,
    value: formatPercentageValue(Rolling24HrPxChangePercent),
    label: t('24 Hour Pct Chg'),
    classModifiers: [Rolling24HrPxChangePercent >= 0 ? '24h-positive' : '24h-negative']
  };
}), _defineProperty(_level1ItemsData, INSTRUMENT_TABLE_ITEMS.bid, function (t, _ref4, instrument) {
  var BestBid = _ref4.BestBid;
  return {
    key: INSTRUMENT_TABLE_ITEMS.bid,
    value: formatNumberToLocale(BestBid, convertIncrementToIntDecimalPlaces(instrument.PriceIncrement)),
    label: t('Bid'),
    classModifiers: ['hideable', 'bid']
  };
}), _defineProperty(_level1ItemsData, INSTRUMENT_TABLE_ITEMS.ask, function (t, _ref5, instrument) {
  var BestOffer = _ref5.BestOffer;
  return {
    key: INSTRUMENT_TABLE_ITEMS.ask,
    value: formatNumberToLocale(BestOffer, convertIncrementToIntDecimalPlaces(instrument.PriceIncrement)),
    label: t('Ask'),
    classModifiers: ['hideable', 'ask']
  };
}), _defineProperty(_level1ItemsData, INSTRUMENT_TABLE_ITEMS.dailyVolume, function (t, _ref6, instrument) {
  var Rolling24HrVolume = _ref6.Rolling24HrVolume;
  return {
    key: INSTRUMENT_TABLE_ITEMS.dailyVolume,
    value: formatNumberToLocale(Rolling24HrVolume, convertIncrementToIntDecimalPlaces(instrument.QuantityIncrement)) + ' ' + getProductSymbol(instrument),
    label: t('24 Hour Volume'),
    classModifiers: ['24h-volume']
  };
}), _defineProperty(_level1ItemsData, INSTRUMENT_TABLE_ITEMS.dailyMin, function (t, _ref7, instrument) {
  var SessionLow = _ref7.SessionLow;
  return {
    key: INSTRUMENT_TABLE_ITEMS.dailyMin,
    value: formatNumberToLocale(SessionLow, convertIncrementToIntDecimalPlaces(instrument.PriceIncrement)),
    label: t('24 Hour Low'),
    classModifiers: ['hideable', '24h-low']
  };
}), _defineProperty(_level1ItemsData, INSTRUMENT_TABLE_ITEMS.dailyMax, function (t, _ref8, instrument) {
  var SessionHigh = _ref8.SessionHigh;
  return {
    key: INSTRUMENT_TABLE_ITEMS.dailyMax,
    value: formatNumberToLocale(SessionHigh, convertIncrementToIntDecimalPlaces(instrument.PriceIncrement)),
    label: t('24 Hour High'),
    classModifiers: ['hideable', '24h-high']
  };
}), _level1ItemsData);